<div id="cac-vehicle-type-div" class="divWhiteBackground">
  <form
    id="cac-vehicle-type-form"
    class="formStyle"
    [formGroup]="vehicleTypeForm"
  >
    <div class="form-group">
      <h2 class="h2-black center">What type of vehicle are you looking for?</h2>

      <div
        class="dark-blue-80 body-black center"
        id="cac-vehicle-type-estd-span"
      >
        Optional: Tell us about the type of vehicle(s) you are interested in, so
        we can better match you with dealers. Select all that apply.
      </div>
    </div>
    <div class="form-group pt-40"></div>
    <div class="form-group">
      <div class="cac-vehicle-type-section custom-display-inline col-md-8">
        <p id="cac-vehicle-type-label" class="control-label">Vehicle Type</p>
        <div class="dropdown-multiselect">
          <button
            type="button"
            class="dropdown-btn"
            (click)="
              showVehicleTypeDropdown = !showVehicleTypeDropdown;
              focusedVehicleTypeIndex = 0;
              showVehicleMakeDropdown = false;
              $event.stopPropagation()
            "
            (keydown)="onVehicleTypeKeydown($event)"
            aria-haspopup="listbox"
            [attr.aria-expanded]="showVehicleTypeDropdown"
          >
            {{ selectedVehicleTypesLabel }}
            <span class="arrow" [class.open]="showVehicleTypeDropdown"
              >&#9662;</span
            >
          </button>
          <div
            #vehicleTypeDropdown
            class="dropdown-content"
            [class.show]="showVehicleTypeDropdown"
            (click)="$event.stopPropagation()"
            (keydown)="onVehicleTypeKeydown($event)"
            tabindex="0"
            role="listbox"
            aria-label="Vehicle type options"
          >
            <label
              *ngFor="let vehicleType of vehicleTypeOptions; let i = index"
              class="dropdown-option"
              [class.focused]="
                showVehicleTypeDropdown && focusedVehicleTypeIndex === i
              "
            >
              <input
                type="checkbox"
                [formControl]="vehicleTypesFormArray.controls[i]"
                [disabled]="vehicleTypesFormArray.controls[i].disabled"
              />
              {{ vehicleType }}
            </label>
          </div>
        </div>
      </div>
      <div class="cac-vehicle-type-make-section custom-display-inline col-md-8">
        <p id="cac-vehicle-type-make-label" class="control-label">
          Vehicle Make
        </p>
        <div class="dropdown-multiselect">
          <button
            type="button"
            class="dropdown-btn"
            (click)="
              showVehicleMakeDropdown = !showVehicleMakeDropdown;
              focusedVehicleMakeIndex = 0;
              showVehicleTypeDropdown = false;
              $event.stopPropagation()
            "
            (keydown)="onVehicleMakeKeydown($event)"
            aria-haspopup="listbox"
            [attr.aria-expanded]="showVehicleMakeDropdown"
          >
            {{ selectedVehicleMakesLabel }}
            <span class="arrow" [class.open]="showVehicleMakeDropdown"
              >&#9662;</span
            >
          </button>
          <div
            #vehicleMakeDropdown
            class="dropdown-content"
            [class.show]="showVehicleMakeDropdown"
            (click)="$event.stopPropagation()"
            (keydown)="onVehicleMakeKeydown($event)"
            tabindex="0"
            role="listbox"
            aria-label="Vehicle make options"
          >
            <label
              *ngFor="let vehicleMake of vehicleMakeOptions; let i = index"
              class="dropdown-option"
              [class.focused]="
                showVehicleMakeDropdown && focusedVehicleMakeIndex === i
              "
            >
              <input
                type="checkbox"
                [formControl]="vehicleMakesFormArray.controls[i]"
                [disabled]="vehicleMakesFormArray.controls[i].disabled"
              />
              {{ vehicleMake }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
